module.exports = __webpack_public_path__ + "static/media/2_step 2.59b614d2.PNG";